import { createSlice } from "@reduxjs/toolkit"
import { EMAIL_AGENT_ANALYTICS } from "../../../../constants/reducer_names"

const initialState = {
    checked_column: [
        "Agent Name",
        "Received Email",
        "Opened Email",
        "Responded Email",
        "Missed Email",
        "Overdue",
        "Discarded Email",
        "Transferred Email",
        "Maximum Emailhandling time",
        "Avg. Email handling time",
        "Interactions from Customer",
        "Interactions from Agent",
        "Total Interactions",
        "Customer Satisfaction (%)"
    ] as any,
    checked_column2: [
        "Agent Name",
        "Avg. Response Time",
        "Avg. Handle Time (AHT)",
        "Maximum Handle Time",
        "Total ACW Time",
        "Avg. Hold Time",
        "First Chat Resolution (%)",
        "Customer Satisfaction (%)"
    ] as any,
    checked_column3: [
        "Agent Name",
        "Chat Type",
        "SL1",
        "SL2",
        "SL3",
        "SL4",
        "SL5",
        "SL6",
        "Total",
        "Overdue",
        "SLA Achieved (%)",
        "SLA Breached (%)"
    ] as any,
    titleMapper_ForDb: {
        "Agent Name": "agentName",
        "Received Email": "receivedEmail",
        "Opened Email": "OpenedEmail",
        "Responded Email": "respondedEmail",
        "Missed Email": "missedEmail",
        "Overdue": "OverdueCount",
        "Discarded Email": "DiscardedEmail",
        "Transferred Email": "transferredEmail",
        "Maximum Emailhandling time": "maximumEmailHandlingTime",
        "Avg. Email handling time": "AverageEmailHandlingTime",
        "Interactions from Customer": "InteractionsFromCustomer",
        "Interactions from Agent": "InteractionsFromAgent",
        "Total Interactions": "totalInteractions",
        "Customer Satisfaction (%)": "CustomerSatisfaction"
    } as any,
    titleMapper_ForDb2: {
        "Agent Name":"agentName",
        "Avg. Response Time":"averageResponseTime",
        "Avg. Handle Time (AHT)":"averageHandledTime",
        "Maximum Handle Time":"MaximumHandledTime",
        "Total ACW Time":"totalACWTime",
        "Avg. Hold Time":"averageHoldtime",
        "First Chat Resolution (%)":"firstChatResolution",
        "Customer Satisfaction (%)":"CustomerSatisfaction"
    } as any,
    titleMapper_ForDb3: {
        "Agent Name":"agentName",
        "Chat Type":"ChatType",
        "SL1":"SL1",
        "SL2":"SL2",
        "SL3":"SL3",
        "SL4":"SL4",
        "SL5":"SL5",
        "SL6":"SL6",
        "Total":"Total",
        "Overdue":"Overdue",
        "SLA Achieved (%)":"SLAAchieved",
        "SLA Breached (%)":"SLABreached"
    } as any,
    updated_TableColumn: [
        {
            title: 'Agent Name',
            dataIndex: 'agentName',
            key: 'agentName',
        },
        {
            title: 'Received Email',
            dataIndex: 'receivedEmail',
            key: 'receivedEmail',
        },
        {
            title: 'Opened Email',
            dataIndex: 'OpenedEmail',
            key: 'OpenedEmail',
        },
        {
            title: 'Responded Email',
            dataIndex: 'respondedEmail',
            key: 'respondedEmail',
        },
        {
            title: 'Missed Email',
            dataIndex: 'missedEmail',
            key: 'missedEmail',
        },
        {
            title: 'Overdue',
            dataIndex: 'OverdueCount',
            key: 'OverdueCount',
        },
        {
            title: 'Discarded Email',
            dataIndex: 'DiscardedEmail',
            key: 'DiscardedEmail',
        },
        {
            title: 'Transferred Email',
            dataIndex: 'transferredEmail',
            key: 'transferredEmail',
        },
        {
            title: 'Maximum Emailhandling time',
            dataIndex: 'maximumEmailHandlingTime',
            key: 'maximumEmailHandlingTime',
        },
        {
            title: 'Avg. Email handling time',
            dataIndex: 'AverageEmailHandlingTime',
            key: 'AverageEmailHandlingTime',
        },
        {
            title: 'Interactions from Customer',
            dataIndex: 'InteractionsFromCustomer',
            key: 'InteractionsFromCustomer',
        },
        {
            title: 'Interactions from Agent',
            dataIndex: 'InteractionsFromAgent',
            key: 'InteractionsFromAgent',
        },
        {
            title: 'Total Interactions',
            dataIndex: 'totalInteractions',
            key: 'totalInteractions',
        },
        {
            title: 'Customer Satisfaction (%)',
            dataIndex: 'CustomerSatisfaction',
            key: 'CustomerSatisfaction',
        }
    ] as any,
    updated_TableColumn2: [
        {
            title: 'Agent Name',
            dataIndex: 'agentName',
            key: 'agentName',
        },
        {
            title: 'Avg. Response Time',
            dataIndex: 'averageResponseTime',
            key: 'averageResponseTime',
        },
        {
            title: 'Avg. Handle Time (AHT)',
            dataIndex: 'averageHandledTime',
            key: 'averageHandledTime',
        },
        {
            title: 'Maximum Handle Time',
            dataIndex: 'MaximumHandledTime',
            key: 'MaximumHandledTime',
        },
        {
            title: 'Total ACW Time',
            dataIndex: 'totalACWTime',
            key: 'totalACWTime',
        },
        {
            title: 'Avg. Hold Time',
            dataIndex: 'averageHoldtime',
            key: 'averageHoldtime',
        },
        {
            title: 'First Chat Resolution (%)',
            dataIndex: 'firstChatResolution',
            key: 'firstChatResolution',
        },
        {
            title: 'Customer Satisfaction (%)',
            dataIndex: 'CustomerSatisfaction',
            key: 'CustomerSatisfaction',
        }
    ] as any,
    updated_TableColumn3: [
        {
            title: 'Agent Name',
            dataIndex: 'agentName',
            key: 'agentName',
        },
        {
            title: 'Chat Type',
            dataIndex: 'ChatType',
            key: 'ChatType',
        },
        {
            title: 'SL1',
            dataIndex: 'SL1',
            key: 'SL1',
        },
        {
            title: 'SL2',
            dataIndex: 'SL2',
            key: 'SL2',
        },
        {
            title: 'SL3',
            dataIndex: 'SL3',
            key: 'SL3',
        },
        {
            title: 'SL4',
            dataIndex: 'SL4',
            key: 'SL4',
        },
        {
            title: 'SL5',
            dataIndex: 'SL5',
            key: 'SL5',
        },
        {
            title: 'SL6',
            dataIndex: 'SL6',
            key: 'SL6',
        },
        {
            title: 'Total',
            dataIndex: 'Total',
            key: 'Total',
        },
        {
            title: 'Overdue',
            dataIndex: 'Overdue',
            key: 'Overdue',
        },
        {
            title: 'SLA Achieved (%)',
            dataIndex: 'SLAAchieved',
            key: 'SLAAchieved',
        },
        {
            title: 'SLA Breached (%)',
            dataIndex: 'SLABreached',
            key: 'SLABreached',
        },
    ] as any
}

const agentAnalyticsEmailSlice = createSlice({
    name: EMAIL_AGENT_ANALYTICS,
    initialState,
    reducers: {
        checkedColumn: (state, { payload }) => {
            state.checked_column = payload.checked_column;
        },
        checkedColumn2: (state, { payload }) => {
            state.checked_column2 = payload.checked_column2;
        },
        checkedColumn3: (state, { payload }) => {
            state.checked_column3 = payload.checked_column3;
        },
        titleMapperForDb: (state, { payload }) => {
            state.titleMapper_ForDb = payload.titleMapper_ForDb;
        },
        titleMapperForDb2: (state, { payload }) => {
            state.titleMapper_ForDb2 = payload.titleMapper_ForDb2;
        },
        titleMapperForDb3: (state, { payload }) => {
            state.titleMapper_ForDb3 = payload.titleMapper_ForDb3;
        },
        updatedTableColumn: (state, { payload }) => {
            state.updated_TableColumn = payload.updated_TableColumn;
        },
        updatedTableColumn2: (state, { payload }) => {
            state.updated_TableColumn2 = payload.updated_TableColumn2;
        },
        updatedTableColumn3: (state, { payload }) => {
            state.updated_TableColumn3 = payload.updated_TableColumn3;
        },


    }
})

export const agentAnalyticsEmailSliceActions = agentAnalyticsEmailSlice.actions;
export const agentAnalyticsEmailSliceReducer = agentAnalyticsEmailSlice.reducer